import {
  Facebook,
  Instagram,
  Language,
  LinkedIn,
  Twitter,
  YouTube,
} from "@mui/icons-material";

const SocialIcon = ({ name, sx }: { name: string; sx?: object }) => {
  const props = { sx: { fontSize: 20, ...sx } };
  switch (name) {
    case "Facebook":
      return <Facebook {...props} />;
    case "Instagram":
      return <Instagram {...props} />;
    case "LinkedIn":
      return <LinkedIn {...props} />;
    case "YouTube":
      return <YouTube {...props} />;
    case "Twitter":
      return <Twitter {...props} />;
    default:
      return <Language {...props} />;
  }
};

export default SocialIcon;
